export default {
  home: '/',
  wizard: '/',
  wizardDropAPin: '/',
  wizardMobile: '/',
  wizardDropAPinMobile: '/',
  error: '/error',
  confirmation: '/',
  recommendationInProgress: '/',
  confirmationUpdateContact: '/',
  recommendation: '/recommendation/:recommendation_data',
  onboarding: '/',
  ddgProdUrl: 'https://seedselector.syngenta.com',
};
